import type { IconData } from '@stacksjs/iconify-core'

export const backwardCircle: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m.973-11.246l1.956-1.398c.905-.646 2.13-.389 2.737.576c.218.346.334.753.334 1.17v5.796c0 1.16-.883 2.102-1.972 2.102a1.9 1.9 0 0 1-1.099-.356l-1.956-1.398C10.818 14.24 10.006 15 9.028 15a1.9 1.9 0 0 1-1.099-.356l-4.055-2.898c-.905-.647-1.146-1.952-.54-2.917c.143-.227.327-.422.54-.575L7.93 5.356c.905-.646 2.13-.389 2.737.576c.157.249.26.53.307.822zm-1.945 6.144V7.102L4.973 10zm5 0V7.102l-3.02 2.159l-.004 1.476z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default backwardCircle
